import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { Types } from "../actions/overtimeActions";

const overtimeReducers = (state, action) => {
	switch (action.type) {
		case Types.OVERTIME_UPDATE_LIST: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.company.settings.overtimes = action.payload.overtime;

			return newState;
		}
		case Types.OVERTIME_ADD: {
			let newState = _.cloneDeep(state);

			if (action.id && action.newCompany) {
				newState.company.newCompany.overtimes =
					(newState.company.newCompany.overtimes && [...newState.company.newCompany.overtimes]) || [];

				newState.company.newCompany.overtimes.push({
					id: action.id,
				});

				return newState;
			}

			if (action.newCompany) {
				newState.company.newCompany.overtimes =
					(newState.company.newCompany.overtimes && [...newState.company.newCompany.overtimes]) || [];

				newState.company.newCompany.overtimes.push({
					id: uuidv4(),
				});
			} else {
				newState.company.settings.overtimes =
					(newState.company.settings.overtimes && [...newState.company.settings.overtimes]) || [];

				newState.company.settings.overtimes.push({
					id: uuidv4(),
					temporary: true,
				});
			}
			return newState;
		}
		case Types.OVERTIME_CLEAR: {
			let newState = _.cloneDeep(state);

			if (action.newCompany) {
				newState.company.newCompany.overtimes = [];
			}

			return newState;
		}
		case Types.OVERTIME_ADVISOR_ADD: {
			let newState = _.cloneDeep(state);

			newState.advisors.settings.overtimes =
				(newState.advisors.settings.overtimes && [...newState.advisors.settings.overtimes]) || [];

			newState.advisors.settings.overtimes.push({
				id: uuidv4(),
				temporary: true,
			});
			return newState;
		}
		case Types.OVERTIME_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);
			if (action.newCompany)
				newState.company.newCompany.overtimes.find((item) => item.id == action.id)[action.field] =
					action.newValue;
			else
				newState.company.settings.overtimes.find((item) => item.id == action.id)[action.field] =
					action.newValue;
			return newState;
		}
		case Types.OVERTIME_ADVISOR_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);

			newState.advisors.settings.overtimes.find((item) => item.id == action.id)[action.field] = action.newValue;

			return newState;
		}
		case Types.OVERTIME_CHECKED_RATE: {
			let newState = _.cloneDeep(state);
			if (action.rateChecked)
				newState.company.newCompany.overtimes.push({
					id: uuidv4(),
					name: `Overtime @ ${action.rate}`,
					rate: action.rate,
					isToil: false,
					fromCheckbox: true,
				});
			else
				newState.company.newCompany.overtimes.splice(
					newState.company.newCompany.overtimes.findIndex((overtime) => overtime.rate == action.rate),
					1,
				);
			return newState;
		}
		case Types.OVERTIME_APPLY_TEMPLATE: {
			let newState = _.cloneDeep(state);

			newState.company.newCompany.selectedOvertimeTemplate = action.template;

			return newState;
		}

		default:
			return state;
	}
};

export default overtimeReducers;
